import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import SidebarData from "./SidebarData";
import { useLocation } from "react-router-dom";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import Can from "./Allow/Can";
const MenuContainer = styled.div`
  width: 280px;
  /* border: 1px solid #ccc; */
  min-height: calc(100vh);
  max-height: calc(100vh);
  position: sticky;
  top: 0;
  background: #040a33;
  overflow-x: hidden;
  overflow-y: auto;
  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  @media (max-width: 768px) {
    width: 100%;
    max-height: none;
    position: relative; // Make it scrollable on mobile
  }
`;

const MenuItem = styled.div`
  padding: 10px 15px;
  cursor: pointer;
  color: #f0f0f0;
  background: ${({ isActive }) => (isActive ? "#f0f0f0" : "#040a33")};
  color: ${({ isActive }) => (isActive ? "#040a33" : "#f0f0f0")};
  position: relative;
  transition: background 0.3s;
  border-radius: 25px 0 0 25px;
  margin: 2px 0;

  &:hover {
    background: #f0f0f0;
    color: #040a33;
  }
`;

const SubMenu = styled.div`
  padding-left: 20px;
  max-height: ${({ isOpen }) => (isOpen ? "none" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease;

  @media (max-width: 768px) {
    padding-left: 15px; // Adjust padding on smaller devices
  }
`;

const ArrowIcon = styled.span`
  position: absolute;
  right: 15px;
  transform: ${({ isOpen }) => (isOpen ? "rotate(90deg)" : "rotate(0)")};
  transition: transform 0.3s;
`;

const IconContainer = styled.span`
  margin-right: 10px;
`;

const Sidebar = () => {
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const activeItemIndex = SidebarData.findIndex(
      (item) =>
        item.link === location.pathname ||
        item.sub.some((subItem) => subItem.link === location.pathname)
    );

    if (activeItemIndex !== -1) {
      setOpenSubMenu(activeItemIndex);
    } else {
      setOpenSubMenu(null);
    }
  }, [location.pathname]);

  const handleMenuClick = (index, link) => {
    if (link && location.pathname !== link) {
      window.location.href = link;
    } else {
      setOpenSubMenu((prevIndex) => (prevIndex === index ? null : index));
    }
  };

  const handleSubMenuClick = (subItemLink) => {
    if (subItemLink === "/admin/order_map") {
      window.open(subItemLink, "_blank");
    } else {
      window.location.href = subItemLink;
    }
  };

  const useInterval = (callback, delay) => {
    const savedCallback = useRef();

    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
      if (!isAlreadyHideCrisp) {
        const tick = () => {
          savedCallback.current();
        };
        if (delay !== null) {
          let id = setInterval(tick, delay);
          return () => clearInterval(id);
        }
      }
    }, [delay]);
  };

  // using interval to hide crisp floating button
  const [isAlreadyHideCrisp, setIsAlreadyHideCrisp] = useState(false);
  const [delay] = useState(1000);
  useInterval(
    () => {
      if (!isAlreadyHideCrisp) {
        if (window && window.CRISP_WEBSITE_ID) {
          window.$crisp.push(["do", "chat:hide"]);
          setIsAlreadyHideCrisp(true);
        }
      }
      //  stop interval after hide button
    },
    !isAlreadyHideCrisp ? delay : null
  );

  return (
    <MenuContainer>
      {SidebarData.map((item, index) => {
        const isActive = location.pathname === item.link;
        const isOpen = openSubMenu === index;
        if (item?.permission) {
          return (
            <Can
              key={index}
              headPermit={item.permission.head}
              keyPermit={item.permission.key}
            >
              <div key={item.name}>
                <MenuItem
                  onClick={() => handleMenuClick(index, item.link)}
                  isActive={
                    isActive ||
                    (isOpen &&
                      item.sub.some(
                        (subItem) => location.pathname === subItem.link
                      ))
                  }
                >
                  <IconContainer>{item.icon}</IconContainer>
                  {item.name}
                  {item.sub.length > 0 && (
                    <ArrowIcon isOpen={isOpen}>
                      <ArrowRightIcon />
                    </ArrowIcon>
                  )}
                </MenuItem>
                <SubMenu isOpen={isOpen}>
                  {item.sub.map((subItem, idx) => {
                    if (subItem?.permission) {
                      return (
                        <Can
                          key={idx}
                          headPermit={subItem.permission.head}
                          keyPermit={subItem.permission.key}
                        >
                          <MenuItem
                            key={subItem.name}
                            onClick={() => handleSubMenuClick(subItem.link)}
                            isActive={location.pathname === subItem.link}
                          >
                            <IconContainer>{subItem.icon}</IconContainer>
                            {subItem.name}
                          </MenuItem>
                        </Can>
                      );
                    } else {
                      return (
                        <MenuItem
                          key={subItem.name}
                          onClick={() => handleSubMenuClick(subItem.link)}
                          isActive={location.pathname === subItem.link}
                        >
                          <IconContainer>{subItem.icon}</IconContainer>
                          {subItem.name}
                        </MenuItem>
                      );
                    }
                  })}
                </SubMenu>
              </div>
            </Can>
          );
        } else {
          return (
            <div key={item.name}>
              <MenuItem
                onClick={() => handleMenuClick(index, item.link)}
                isActive={
                  isActive ||
                  (isOpen &&
                    item.sub.some(
                      (subItem) => location.pathname === subItem.link
                    ))
                }
              >
                <IconContainer>{item.icon}</IconContainer>
                {item.name}
                {item.sub.length > 0 && (
                  <ArrowIcon isOpen={isOpen}>
                    <ArrowRightIcon />
                  </ArrowIcon>
                )}
              </MenuItem>
              <SubMenu isOpen={isOpen}>
                {item.sub.map((subItem, idx) => {
                  if (subItem?.permission) {
                    return (
                      <Can
                        key={idx}
                        headPermit={subItem.permission.head}
                        keyPermit={subItem.permission.key}
                      >
                        <MenuItem
                          key={subItem.name}
                          onClick={() => handleSubMenuClick(subItem.link)}
                          isActive={location.pathname === subItem.link}
                        >
                          <IconContainer>{subItem.icon}</IconContainer>
                          {subItem.name}
                        </MenuItem>
                      </Can>
                    );
                  } else {
                    return (
                      <MenuItem
                        key={subItem.name}
                        onClick={() => handleSubMenuClick(subItem.link)}
                        isActive={location.pathname === subItem.link}
                      >
                        <IconContainer>{subItem.icon}</IconContainer>
                        {subItem.name}
                      </MenuItem>
                    );
                  }
                })}
              </SubMenu>
            </div>
          );
        }
      })}
    </MenuContainer>
  );
};

export default Sidebar;
